import { render, staticRenderFns } from "./ModalStack.htm?vue&type=template&id=4e9c501c&scoped=true&"
import script from "./ModalStack.js?vue&type=script&lang=js&"
export * from "./ModalStack.js?vue&type=script&lang=js&"
import style0 from "./ModalStack.scss?vue&type=style&index=0&id=4e9c501c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9c501c",
  null
  
)

export default component.exports